@if (warningKey; as key) {
  <div class="data-banner display-flex row--valign-top row--nowrap mb--sm px--sm py--xs text-xs semi-bold color--navy bg--warning-bg">
    <span class="color--warning bold mr--xs" aria-hidden="true">&#9432;</span>
    <span class="flex-1">{{ key | translate:{ date: dataSinceLabel } }}</span>
  </div>
}
